import Repository from './Repository';

import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/export`;

export default {
  /**
     * Exports the instance as a VTT File
     * @returns {Promise<AxiosResponse<T>>}
     */
  exportAsVTT() {
    return Repository.get(`${base}/vtt`, { responseType: 'blob' });
  },
  /**
     * Exports the instance as a SRT File
     * @returns {Promise<AxiosResponse<T>>}
     */
  exportAsSRT() {
    return Repository.get(`${base}/srt`, { responseType: 'blob' });
  },
  /**
     * Exports the instance to the Backend.
     * @returns {Promise<AxiosResponse<T>>}
     */
  exportToBackend() {
    return Repository.get(`${base}/backend`);
  },
};
